
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import mainLandPackageList from '@/store/entities/back-mainlandpackage'
    //class AddShipment {
    //    mainlandShipment: string;
    //}
    @Component
    export default class CreateLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        //Shipment: AddShipment = new AddShipment();
        selectMainLandPackage: mainLandPackageList = new mainLandPackageList();
        MainLandPackage: Array<mainLandPackageList> = [];
        MainLandPackageSelect: Array<mainLandPackageList> = [];
        mainlandShipment: string = "";
        type: number = 0;
        created() {
           
            this.get();
        }
        async get() {

            this.MainLandPackage = await this.$store.dispatch({
                type: 'mainlandpackage/getMainLandPackageList',
                data: { }
            });
            if (this.MainLandPackage.length > 0) {
                    var _this = this;

                this.MainLandPackageSelect = this.MainLandPackage.filter(function (item) { return item.cargoCategory == _this.$store.state.backstockorder.cargoCategory });
                    if (this.MainLandPackageSelect.length > 0) {
                        this.selectMainLandPackage.id = this.MainLandPackageSelect[0].id;
                    }


                    //  this.selectuser.id = this.user[0].id;
                }

        }
        async updatePackage() {
            this.get();
        }
        async save() {


            var ids = this.$store.state.backstockorder.ids;
            await this.$store.dispatch({

                type: 'backstockorder/updatePackageStatus',
                data: { ids: ids, PackageStatus: 4, mainLandPackageId: this.selectMainLandPackage.id }
            });
            

            (this.$refs.shipmentForm as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);
        }



        cancel() {
            (this.$refs.shipmentForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
             
            }
        }
        //shipmentRule = {
        //    mainlandShipment: [
        //        { required: true, message: '本土物流单号快递不能为空', trigger: 'blur' }
        //    ]
        //};

    }
